import React, { useRef, useState } from "react";
import AlgoBullsWelcome from "./AlgoTestWelcome/AlgoTestWelcome";
import TradingStrategies from "./TradingStrategies/TradingStrategies";
import AlgoTestWhyChoose from "./algoTestWhyChoose/algoTestWhyChoose"
import congratulation from "./../../Images/congratulation-img.png";
// import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import CallTrackApi from "../Activity_Track/CallTrackApi";
import LoginPopup from "../CommonUI/LoginPopup/LoginPopup";

function AlgoTest() {
    const childRef = useRef(null);
    const [show, setShow] = useState(false);
    window.scrollTo(0, 0)
    const [welcomeData, setWelcomeSection] = useState(
        {
            title: "Automate your option trading strategies with target & stoploss",
        },
        []
    );
    const clickToggleLoginPopup = (showhide) => {
        // window.open(
        //     'https://ekyc.moneysukh.com:8443/index.aspx',
        //     '_blank'
        // );
        childRef.current.changeTogglePopup(showhide);
    }
    // CallTrackApi("AlgoBTest", window.location.href);

    return (
        <>
            <main class="AlgoTestMain">
                <AlgoBullsWelcome data={welcomeData} />
                <TradingStrategies />
                <section class="algoTestbenefits_section">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="section-heading center">
                                    Benefits Of <span>Automated Trading</span>
                                </div>
                                <div class="algoTestbenefitsgrid-container">
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 1</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Trend</div>
                                            <p>Trades are executed on the basis of popular trend</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 2</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Index rebalancing</div>
                                            <p>Traders tend to focus on trades that’s have rebalancing effect</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 3</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Opportunity</div>
                                            <p>Track and trade the real opportunity arises in live markets</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 4</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Fast</div>
                                            <p>Trade execution at lightining speed</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 5</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Accuracy</div>
                                            <p>Trades get double checked to prevent any basic errors</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 6</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Emotions</div>
                                            <p>Automated trading makes your trading more decisive & emotions free</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 7</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Diversify</div>
                                            <p>Execute complex strategies with multiple time frame
                                            </p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 8</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Cost</div>
                                            <p>Reduced transaction cost due to lack of human intervention</p>
                                        </div>
                                    </div>
                                    <div class="algoTestbenefits_panel">
                                        <div class="algoTestbenefitsgrid_num">
                                            <span> 9</span>
                                        </div>
                                        <div class="algoTestbenefits_content">
                                            <div class="head">Interface</div>
                                            <p>Simple and powerful UI</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <AlgoTestWhyChoose />
                <section class="open-account-sc"><div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="head">Open Your Account</div>
                            <div class="img-container">
                                <img className="img-fluid" src={congratulation} alt="congratulation" />
                            </div>
                            <button class="bttn" onClick={() => clickToggleLoginPopup(true)}>
                                    Get started
                                </button>
                        </div>
                    </div>
                </div>
                </section>
                <LoginPopup show={show} ref={childRef} />
            </main>
        </>
    );
}
export default AlgoTest;

